export const BASEURL = `https://community.venco.africa/api/method`
export const BASE_DOMAIN = `https://community.venco.africa`
